import { mapMutations, mapGetters } from 'vuex'
import triplaLocalStorage from 'utilities/triplaLocalStorage'
import EventBus from 'utilities/EventBus'
import { replaceQuery } from 'utilities/url'
import { localeMapping } from 'locales/utilities'
import _values from 'lodash/values'

export default {
  data() {
    return {
      reloadKey: 0
    }
  },

  created() {
    EventBus.$on('reloadView', () => {
      this.reloadKey++
    })
  },

  computed: {
    ...mapGetters({
      getBookLanguages: 'setting/getBookLanguages',
      currentUser: 'membership/getCurrentUser'
    })
  },

  methods: {
    ...mapMutations('search', ['setRooms', 'setPlans']),
    ...mapMutations('membership', ['setLoggedInUser']),
    changeLocale(value) {
      const bookLanguages = this.getBookLanguages
      const locales = bookLanguages.length > 0 ? bookLanguages : _values(localeMapping)
      const locale = locales.find((l) => value === l) || locales[0]

      this.$i18n.locale = locale
      triplaLocalStorage.setItem('triplabot_locale', locale)
      this.setLoggedInUser(this.currentUser)
      this.reloadKey++
      this.setRooms(null)
      this.setPlans(null)
      replaceQuery({ exclude: ['locale'] })
    }
  }
}
